import { Component } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'dashboard',
  styles: [`
    .welcome {
      height: 60px;
      background: url("../assets/img/rol/welcome-logo.png") no-repeat transparent;
      text-align: center;
      margin: 5px;
    }
  `],
  template: `
    <h1 class="welcome"></h1>
  `
})
export class DashboardComponent {

  constructor() {
  }
}



// WEBPACK FOOTER //
// ./src/app/dashboard/dashboard.component.ts